import * as PIXI from 'pixi.js';
import Angle from './Angle';

export default class Point extends PIXI.Point {
  /**
   * Get the angle of the vector represented by this point.
   * Note that since we're working with on-screen graphics, the quadrants are different than in pure algebra.
   *
   * @returns {Angle}
   */
  get angle() {
    const { x, y } = this;
    const inverseTangent = Math.atan(Math.abs(x) / Math.abs(y));

    if (x >= 0 && y < 0) {
      // top right quadrant
      return new Angle(Math.PI / 2 - inverseTangent);
    } else if (x < 0 && y < 0) {
      // top left quadrant
      return new Angle(inverseTangent + Math.PI / 2);
    } else if (x < 0) {
      // bottom left quadrant
      return new Angle((3 * Math.PI) / 2 - inverseTangent);
    } else {
      // bottom right quadrant
      return new Angle(inverseTangent + (3 * Math.PI) / 2);
    }
  }

  /**
   * Add a point to this one and return the sum as a new Point
   *
   * @param point {Point}
   * @returns {Point}
   */
  plus(point) {
    return new Point(this.x + point.x, this.y + point.y);
  }

  /**
   * Subtract a point from this one and return the difference as a new Point
   *
   * @param point {Point}
   * @returns {Point}
   */
  minus(point) {
    return new Point(this.x - point.x, this.y - point.y);
  }
}
